var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyPrescriptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139.722,
    height: 115.744,
    viewBox: "0 0 139.722 115.744",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25884",
    "data-name": "Group 25884",
    transform: "translate(2.001 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10985",
    "data-name": "Path 10985",
    d: "M167.945,166.774a2.157,2.157,0,0,1-1.36-2.012V156.4H113.749v8.36a2.73,2.73,0,0,1-1.365,2.145h-.008a20.688,20.688,0,0,0-12.841,19.2v54.026a9.257,9.257,0,0,0,9.239,9.273h62.7a9.333,9.333,0,0,0,9.321-9.28V186.106a20.79,20.79,0,0,0-12.854-19.333Zm-.433,47.718a2.163,2.163,0,0,1-2.163,2.163H149.9V232.1a2.163,2.163,0,0,1-2.163,2.163H132.6a2.164,2.164,0,0,1-2.163-2.163V216.655H115.293a2.164,2.164,0,0,1-2.163-2.163V200.279a2.164,2.164,0,0,1,2.163-2.163h15.141v-15.45A2.164,2.164,0,0,1,132.6,180.5h15.14a2.164,2.164,0,0,1,2.163,2.163v15.45h15.45a2.164,2.164,0,0,1,2.163,2.163v14.213Z",
    transform: "translate(-99.536 -137.663)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10986",
    "data-name": "Path 10986",
    d: "M140,74.375h58.4V93.223H140Z",
    transform: "translate(-128.569 -74.375)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10987",
    "data-name": "Path 10987",
    d: "M531.791,425.47H518.437v16.994h13.354a8.5,8.5,0,1,0,0-16.994Z",
    transform: "translate(-405.502 -330.719)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10988",
    "data-name": "Path 10988",
    d: "M535.83,363.774,523.347,359.2l-5.279,14.4h13.46a12.776,12.776,0,0,1,8.322,3.076,8.5,8.5,0,0,0-4.02-12.9Z",
    transform: "translate(-405.239 -282.349)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10989",
    "data-name": "Path 10989",
    d: "M438.5,347.985a8.451,8.451,0,0,0,4.79,4.409l12.235,4.484h.282l5.824-15.886-12.484-4.575h0a8.509,8.509,0,0,0-10.649,11.566Zm4.176-.2h0a2.163,2.163,0,0,1,2.776-1.287l9.872,3.62a2.163,2.163,0,1,1-1.489,4.061l-9.872-3.619h0a2.164,2.164,0,0,1-1.287-2.775Z",
    transform: "translate(-346.562 -265.458)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10990",
    "data-name": "Path 10990",
    d: "M426.16,433.969a8.509,8.509,0,0,0,8.509,8.5H447.9V425.472H434.669a8.509,8.509,0,0,0-8.509,8.5Zm21.188,4.48a2.163,2.163,0,0,1-2.163,2.163H434.669a2.163,2.163,0,0,1,0-4.326h10.515A2.164,2.164,0,0,1,447.348,438.45Z",
    transform: "translate(-338.05 -330.721)",
    fill: "none",
    stroke: "#2c53bb",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPrescriptions);
export default __webpack_public_path__ + "static/media/my-prescriptions.07a814c25c8feb79d8aca9f9c7398cf9.svg";
export { ForwardRef as ReactComponent };